import { useSelector } from "react-redux"
import { VinFieldProps } from "@tm/controls"
import { useLocalization } from "@tm/localization"
import { useActions } from "@tm/morpheus"
import GeneralVehicleForm from "@bundles/damage-calculation-dat/components/_shared/GeneralVehicleFields"
import { useCallback, useMemo } from "react"
import { getAswegasVehicleSchema } from "../../../data/helpers"
import { useContainer } from "../../../data/repositories"
import { MainActions, managerSelector, summarySelector } from "../../main/business"

export default function VehicleInfoFields() {
    const localization = useLocalization()
    const { translateText } = localization
    const actions = useActions(MainActions, "updateFieldValue", "setValidateFields")
    const container = useContainer()

    const selector = useSelector(summarySelector)
    const { vehicle } = useSelector(managerSelector)
    const fieldsSchema = useMemo(() => getAswegasVehicleSchema(translateText), [translateText])

    const handleGetVinSuggestions = useCallback(
        (val: string) => {
            return container.action("getVinSuggestions")(val, vehicle?.tecDocTypeId)
        },
        [container, vehicle?.tecDocTypeId]
    )

    const handleFormValid = useCallback(
        (isValid: boolean) => {
            actions.setValidateFields("vehicleValid", isValid)
        },
        [actions]
    )

    const onHandleUpdateValue = useCallback(
        (path: string, value: string | Date | number) => {
            actions?.updateFieldValue(path, value)
        },
        [actions]
    )

    const vinFieldProps: VinFieldProps = useMemo(
        () => ({
            getSuggestionDataAsync: handleGetVinSuggestions,
        }),
        [handleGetVinSuggestions]
    )

    if (!vehicle) {
        return null
    }

    return (
        <GeneralVehicleForm
            onFormValid={handleFormValid}
            schema={fieldsSchema}
            fields={selector?.fields}
            onUpdateFieldValue={onHandleUpdateValue}
            vehicle={vehicle}
            vinFieldProps={vinFieldProps}
        />
    )
}
